<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="create-person-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Create Person
            </h4>
          </div>

          <div class="modal-body">
            <TextFormGroup
                v-model="data.name"
                name="name"
                label="Name"
                :error="(errors.name || [])[0]"
            />

            <TextFormGroup
                v-model="data.title"
                name="title"
                label="Title"
                :error="(errors.title || [])[0]"
            />

            <EmailFormGroup
                v-model="data.email"
                name="email"
                label="Email"
                :error="(errors.email || [])[0]"
            />

            <TextFormGroup
                v-model="data.cell_phone"
                name="cell_phone"
                label="Cell Phone"
                :error="(errors.cell_phone || [])[0]"
            />

            <TextFormGroup
                v-model="data.work_phone"
                name="work_phone"
                label="Work Phone"
                :error="(errors.work_phone || [])[0]"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import EmailFormGroup from '@/vendor/forms/FormGroups/Block/Email'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {EmailFormGroup, TextFormGroup},

  mixins: [Errors],

  props: ['companyId'],

  data() {
    return {
      data: {}
    }
  },

  mounted() {
    this.listenForClose()
  },

  methods: {
    listenForClose() {
      $('#create-person-modal').on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.post('/api/v2/people', {...this.data, company_id: this.companyId})
          .then(response => {
            notify.success('The person was saved')

            this.$emit('created', response.data.data)

            $('#create-person-modal').modal('hide')
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {}
    }
  }
}
</script>
